{
    "component-card-search-list.empty-state.title.non-final": "<strong>Collega questo repository a un componente software</strong>",
    "component-card.add-chat-channel": "Aggiungi canale di chat",
    "component-card.chat-channels": "Canali di chat",
    "component-card.expander.show-more-link": "Mostra altri {formattedCount}"
}
